module.exports = __webpack_public_path__ + "static/media/ioelogo.705cf900.png";